import MarkerClusterer from './markerclusterer';

$(document).ready(function() {
    $('body').agrafa();
});

(function($) {
    $.fn.agrafa = function() {
        //Dom objects
        var body = $(this);

        var main = {
            pane: $('.main'),
        };

        var overlay = {
            button: $('.collapse-overlay'),
            pane: $('.overlay'),
            content: $('.overlay-content'),
        };

        var sidebar = {
            button: $('.collapse-sidebar'),
            pane: $('.sidebar'),
            scrollable: $('.sidebar-main'),
            size: {
                default: '30%',
                collapsed: '50px',
            },
            state: 'default',
        };

        var animationTiming = 300;

        var campaigns = {
            group: $('.campaigns', sidebar.pane),
            items: $('.campaign', sidebar.pane),
            parts: $('.tag', sidebar.pane),
            photos: $('.photos a', sidebar.pane),
            download: $('.btn', sidebar.pane),
        };

        //read data
        var data = typeof window.campaignsJson !== 'undefined' ? window.campaignsJson : '[]'; //global input var

        //map and timeline vars
        var map, markers, infoWindow;
        var markerCluster;

        var timeline = {
            bars: $('.timeline-bars'),
            grid: $('.timeline-grid'),
        };
        var monthNames = [
            'Jan',
            'Feb',
            'Maa',
            'Apr',
            'Mei',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Okt',
            'Nov',
            'Dec',
        ];

        //--------------------------------------------------------interface behaviour
        //sidepane behaviour
        sidebar.button.on('click', function() {
            //set main width
            main.pane.animate(
                {
                    width:
                        sidebar.state == 'collapsed'
                            ? complementWidth(sidebar.size.default)
                            : complementWidth(sidebar.size.collapsed),
                },
                animationTiming,
                function() {
                    google.maps.event.trigger(map, 'resize');
                }
            );

            //delay showing of content until bar is back open
            if (sidebar.state == 'collapsed') {
                sidebar.pane.animate({ width: sidebar.size.default }, animationTiming, function() {
                    body.removeClass('sidebar-is-collapsed');
                    sidebar.state = 'default';
                });
            } else {
                body.addClass('sidebar-is-collapsed');
                sidebar.state = 'collapsed';
                sidebar.pane.animate({ width: sidebar.size.collapsed }, animationTiming);
            }
        });

        //overlay behaviour
        overlay.button.on('click', function() {
            body.toggleClass('overlay-is-collapsed');
            overlay.content.slideToggle(animationTiming);
        });

        //campaign selection
        campaigns.items.on('click', function() {
            toggleCampaign($(this));
        });

        campaigns.photos.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            $.fancybox.open(campaigns.photos, {}, campaigns.photos.index(this));
        });

        campaigns.download.on('click', function(e) {
            e.stopPropagation();
        });

        //list select
        campaigns.parts.on('click', function(e) {
            e.stopPropagation();
            togglePart($(this));
            return false;
        });

        //--------------------------------------------------------interface initialization
        //set initial layout
        setPanes();

        //before log in: no map
        if (document.getElementById('map')) {
            var myOptions = {
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            };
            map = new google.maps.Map(document.getElementById('map'), myOptions);
            infoWindow = new google.maps.InfoWindow({});
            markerCluster = new MarkerClusterer(map, [], {
                enableRetinaIcons: true,
                gridSize: 40,
            });

            //show first campaign if available
            if (campaigns.items.size() > 0) {
                //init timeline
                makeTimeline();
                //select first
                toggleCampaign(campaigns.items.first());
            } else {
                campaigns.group.html('Geen campagnes gevonden');
                overlay.pane.remove();
                defaultMapLocation();
            }
        }

        //bind resize behaviour
        $(window).resize(function() {
            setPanes();
        });

        //return for jquery chaining
        return this;

        //--------------------------------------------------------internal functions
        //--------------------------DOM functions
        function complementWidth(item) {
            var value;
            if (item.search('%') > 0) {
                value = item.replace('%', '');
                value = 100 - value + '.1%';
            } else {
                value = item.replace('px', '');
                value = body.width() - value + 'px';
            }
            return value;
        }

        function setPanes() {
            sidebar.pane.width(sidebar.size[sidebar.state]);
            main.pane.width(complementWidth(sidebar.size[sidebar.state]));
        }

        function toggleCampaign(element) {
            if (element.hasClass('campaign-is-active')) {
                deselectAllParts(element);
            } else {
                selectAllParts(element);
            }
            updateMarkers();
        }

        function selectAllParts(element) {
            setCampaignActive(element);
            //set parts
            var parts = $('.tag', element);
            parts.each(function() {
                showPart($(this));
            });
        }

        function deselectAllParts(element) {
            setCampaignInactive(element);
            //clear parts
            var parts = $('.tag', element);
            parts.each(function() {
                hidePart($(this));
            });
        }

        function setCampaignActive(element) {
            //deselect other campaign
            deselectAllParts($('.campaign-is-active'));
            //select this one
            element.addClass('campaign-is-active');
            makeMarkers(element.data('campaign-id'));

            var timelineElement = getTimeLineElementForCampaign(element);
            setTimelineCampaignActive(timelineElement);
        }

        function setCampaignInactive(element) {
            element.removeClass('campaign-is-active');
            removeMarkers();

            var timelineElement = getTimeLineElementForCampaign(element);
            setTimelineCampaignInactive(timelineElement);
        }

        function getTimeLineElementForCampaign(element) {
            return $('[data-campaign-id=' + element.data('campaign-id') + ']', overlay.pane);
        }

        function togglePart(element) {
            var campaignElement = element.parents('.campaign');

            if ($('.tag.active', campaignElement).size() == $('.tag', campaignElement).size()) {
                $('.tag.active', campaignElement)
                    .not(element)
                    .each(function() {
                        hidePart($(this));
                    });
            } else {
                if (element.hasClass('active')) {
                    hidePart(element);
                    //last item?
                    if ($('.tag.active', campaignElement).size() == 0) {
                        setCampaignInactive(campaignElement);
                    }
                } else {
                    //first item?
                    if ($('.tag.active', campaignElement).size() == 0) {
                        setCampaignActive(campaignElement);
                    }
                    showPart(element);
                }
            }
            updateMarkers();
        }

        function showPart(element) {
            element.addClass('active');
            element
                .children('span')
                .css('background-color', element.parents('.campaign').data('campaign-color'));
            showMarkers(element.data('campaignpart-id'));
        }

        function hidePart(element) {
            element.removeClass('active');
            element.children('span').css('background-color', '#e6e6e6');
            hideMarkers(element.data('campaignpart-id'));
        }

        function setTimelineCampaignActive(element) {
            $('.active', timeline.bars)
                .not(element)
                .removeClass('active');
            element.addClass('active');
        }

        function setTimelineCampaignInactive(element) {
            element.removeClass('active');
        }

        //--------------------------data functions
        function getCampaignData(campaignId) {
            for (var index in data) {
                if (parseInt(data[index].id) == parseInt(campaignId)) {
                    return data[index];
                }
            }
        }

        function getPartData(partId) {
            for (var campaignIndex in data) {
                for (var partIndex in data[campaignIndex].campaign_parts) {
                    if (
                        parseInt(data[campaignIndex].campaign_parts[partIndex].id) ==
                        parseInt(partId)
                    ) {
                        return data[campaignIndex].campaign_parts[partIndex];
                    }
                }
            }
        }

        function getVisibleParts(element) {
            var parts = new Array();
            $('.tag.active', element).each(function() {
                parts.push($(this).data('campaignpart-id'));
            });
            return parts;
        }

        function getPartPoints(partId) {
            var partData = getPartData(partId);
            var points = new Object();

            for (var pointIndex in partData.point_list.sub_point_list_points) {
                var pointData = partData.point_list.sub_point_list_points[pointIndex].point;

                //be sure that there is a point
                if (pointData != null && pointData.active) {
                    for (var i = 0; i < (window.frameCountsJson[pointData.id] || 1); i++) {
                        var partPointKey = pointData.id + '_' + i;

                        //don't set it twice
                        if (points[partPointKey] == undefined) {
                            points[partPointKey] = pointData;
                        }
                    }
                }
            }
            return points;
        }

        function getPointInfo(pointId, campaignId) {
            var campaignData = getCampaignData(campaignId);

            var formats = {};
            var address = new Array();

            for (var partIndex in campaignData.campaign_parts) {
                var partData = campaignData.campaign_parts[partIndex];
                for (var pointIndex in partData.point_list.sub_point_list_points) {
                    var subPointListPointData =
                        partData.point_list.sub_point_list_points[pointIndex];
                    var pointData = subPointListPointData.point;
                    //be sure that there is a point
                    if (pointData != null) {
                        if (pointData.id == pointId) {
                            var title = pointData.name;
                            if (address.length == 0) {
                                address.push(pointData.address);
                                address.push(pointData.postal + ' ' + pointData.city);
                            }

                            formats[partData.point_list.format.name] =
                                (formats[partData.point_list.format.name] || 0) +
                                subPointListPointData.amount;
                        }
                    }
                }
            }
            var info = '<strong>' + title + '</strong><br>';
            info += address.join('<br>');
            info += '<br><br>';
            info += formats.length > 1 ? 'Formaten' : 'Formaat';
            info += ':<br>';
            for (var format in formats) {
                info += `&bull; ${formats[format]}x ${format}<br>`;
            }
            return info;
        }

        //--------------------------map functions
        function makeMarkers(campaignId) {
            var campaignData = getCampaignData(campaignId);
            markers = new Object();

            //collect points for campaign
            for (var partIndex in campaignData.campaign_parts) {
                var points = getPartPoints(campaignData.campaign_parts[partIndex].id);
                $.extend(markers, points);
            }

            //replace point data with real marker
            for (var markerIndex in markers) {
                var pointData = markers[markerIndex];
                var myLatlng = new google.maps.LatLng(pointData.lat, pointData.lng);
                //var image = '/images/marker.php?color=' + campaignData.color.replace('#', '');
                var marker = new google.maps.Marker({
                    position: myLatlng,
                    title: pointData.pointId + ': ' + pointData.name,
                    pointId: pointData.id,
                    //icon: new google.maps.MarkerImage(image, null, null, null, new google.maps.Size(40,40))
                });
                google.maps.event.addListener(marker, 'click', function() {
                    infoWindow.setContent(getPointInfo(this.pointId, campaignId));
                    infoWindow.open(map, this);
                });
                marker.setVisible(false);
                markers[markerIndex] = marker;
            }

            var clusterStyle = {
                textColor: '#000000',
                textSize: 14,
                //url: 'layout/images/markers.php?color=' + campaignData.color.replace('#', ''),
                url: '/images/markers.png',
                height: 40,
                width: 40,
            };
            var clusterStyles = [clusterStyle, clusterStyle, clusterStyle];
            markerCluster.setStyles(clusterStyles);
            return markers;
        }

        function removeMarkers() {
            for (var markerIndex in markers) {
                markers[markerIndex].setMap(null);
            }
            markerCluster.clearMarkers();
        }

        function showMarkers(partId) {
            var points = getPartPoints(partId);
            for (var id in points) {
                markers[id].setMap(map);
                markers[id].setVisible(true);
            }
        }

        function hideMarkers(partId) {
            var points = getPartPoints(partId);

            //get all visible parts and points
            var campaignElement = $('[data-campaignpart-id=' + partId + ']').parents('.campaign');
            var visibleParts = getVisibleParts(campaignElement);
            var keepPoints = new Object();
            for (var partIndex in visibleParts) {
                $.extend(keepPoints, getPartPoints(visibleParts[partIndex]));
            }
            //only hide points that are not visible elsewhere
            for (var id in points) {
                if (keepPoints[id] == undefined) {
                    markers[id].setVisible(false);
                }
            }
        }

        function updateMarkers() {
            var visibleParts = getVisibleParts($('.campaigns')[0]);

            var visibleMarkers = new Array();
            for (var markerIndex in markers) {
                if (markers[markerIndex].getVisible()) {
                    if (window.pointOccurrenceCountsJson[markers[markerIndex].pointId]) {
                        markers[markerIndex].occurrenceCount = window.pointOccurrenceCountsJson[markers[markerIndex].pointId]
                            .filter((campaignPartId) => visibleParts.find(partId => partId == campaignPartId))
                            .length;
                    } else {
                        markers[markerIndex].occurrenceCount = 0;
                    }
                    visibleMarkers.push(markers[markerIndex]);
                }
            }
            if (visibleMarkers.length == 0) {
                defaultMapLocation();
            } else {
                var bounds = new google.maps.LatLngBounds();
                for (var i = 0, LtLgLen = visibleMarkers.length; i < LtLgLen; i++) {
                    bounds.extend(visibleMarkers[i].position);
                }
                map.fitBounds(bounds);
            }
            markerCluster.clearMarkers();
            markerCluster.addMarkers(visibleMarkers);
        }

        function defaultMapLocation() {
            var address = 'Antwerpen';
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: address }, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    map.setCenter(results[0].geometry.location);
                    map.fitBounds(results[0].geometry.bounds);
                }
            });
        }

        //--------------------------timeline functions
        function getTotalRange() {
            var dates = new Array();
            for (var campaignIndex in data) {
                collectStartEndFromParts(data[campaignIndex].campaign_parts, dates);
            }
            return makeRangeFromDates(dates);
        }

        function getCampaignRange(campaignId) {
            var campaignData = getCampaignData(campaignId);
            var dates = new Array();
            collectStartEndFromParts(campaignData.campaign_parts, dates);

            return makeRangeFromDates(dates);
        }

        function collectStartEndFromParts(parts, datesArray) {
            for (var partIndex in parts) {
                datesArray.push(convertDateFromEuropeanDate(parts[partIndex].start_date));
                datesArray.push(convertDateFromEuropeanDate(parts[partIndex].end_date));
            }
            return datesArray;
        }

        function makeTimeline() {
            var totalRange = getTotalRange();
            var unit = 100 / totalRange.duration;

            //make horizontal bars
            campaigns.items.each(function() {
                var campaignId = $(this).data('campaign-id');
                var range = getCampaignRange(campaignId);

                var offset = dateDiff(totalRange.from, range.from) * unit;
                var length = range.duration * unit;
                var color = $(this).data('campaign-color');
                var title = $('.campaign-details h2', $(this)).text();

                //bar in DOM
                var element = $('<div></div>')
                    .addClass('timeline-campaign')
                    .attr('data-campaign-id', campaignId)
                    .css({ 'margin-left': offset + '%', width: length + '%' })
                    .appendTo(timeline.bars);

                $('<div></div>')
                    .addClass('timeline-bar')
                    .css('background', color)
                    .appendTo(element);
                $('<div></div>')
                    .addClass('timeline-text')
                    .text(title)
                    .appendTo(element);

                //append start and end
                $('<div></div>')
                    .addClass('timeline-start')
                    .text(getEuropeanDate(range.from))
                    .appendTo(element);
                $('<div></div>')
                    .addClass('timeline-end')
                    .text(getEuropeanDate(range.to))
                    .appendTo(element);
            });

            //today marker
            var today = new Date();
            var todayOffset = dateDiff(totalRange.from, today) * unit;
            $('<div></div>')
                .addClass('timeline-grid-today')
                .css({ left: todayOffset + '%' })
                .appendTo(timeline.grid);

            //month grid
            var monthOnGrid = new Date();
            monthOnGrid.setDate(1);
            monthOnGrid.setMonth(totalRange.from.getMonth());
            monthOnGrid.setFullYear(totalRange.from.getFullYear());

            while (monthOnGrid < totalRange.to) {
                var monthOffset = dateDiff(totalRange.from, monthOnGrid) * unit;
                var gridLine = $('<div></div>')
                    .addClass('timeline-grid-line')
                    .css({ left: monthOffset + '%' })
                    .appendTo(timeline.grid);
                $('<div></div>')
                    .addClass('timeline-grid-line-month')
                    .text(getMonthName(monthOnGrid))
                    .appendTo(gridLine);
                monthOnGrid.setMonth(monthOnGrid.getMonth() + 1);
            }

            //behaviour
            timeline.bars.on('click', '.timeline-campaign', function() {
                var campaignElement = $(
                    '[data-campaign-id=' + $(this).data('campaign-id') + ']',
                    sidebar.pane
                );
                toggleCampaign(campaignElement);

                if ($(this).hasClass('active')) {
                    sidebar.scrollable.animate(
                        {
                            scrollTop: $(campaignElement).position().top,
                        },
                        animationTiming
                    );
                }
            });
        }

        function dateDiff(start, end) {
            var oneDay = 24 * 60 * 60 * 1000;
            return Math.floor((start - end) / oneDay);
        }

        function makeRangeFromDates(dates) {
            dates = dates.sort(function(a, b) {
                if (a > b) return 1;
                if (a < b) return -1;
                return 0;
            });
            var range = {
                from: dates[0],
                to: dates[dates.length - 1],
                duration: dateDiff(dates[0], dates[dates.length - 1]),
            };
            return range;
        }

        function convertDateFromEuropeanDate(date) {
            //get ready for UTC notation. eg new Date('2011-04-11T11:51:00')
            date = date.replace(' ', 'T');
            return new Date(date);
        }

        function getEuropeanDate(date) {
            return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
        }

        function getMonthName(date) {
            var month = monthNames[date.getMonth()];
            return month;
        }
    };
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/front/modules/agrafa.js